import { useState } from "react";
import InitialSelection from "./components/InitialSelection.jsx";
import InterviewForm from "./components/InterviewForm.jsx";
import QuoteCheckForm from "./components/QuoteCheckForm.jsx";
import OutputArea from "./components/OutputArea.jsx";
import GraphicsGenerator from "./components/GraphicsGenerator.jsx";
import logo from "/logo-update.png";
import "./App.css";

function App() {
  const [currentView, setCurrentView] = useState("initial");
  const [generatedEmail, setGeneratedEmail] = useState({
    subject: "",
    body: "",
  });
  const [showOutput, setShowOutput] = useState(false);
  const [startFresh, setStartFresh] = useState(false);

  const handleSelectForm = (formType) => {
    setCurrentView(formType);
    setShowOutput(false);
    setGeneratedEmail({ subject: "", body: "" });
    setStartFresh(false);
  };

  const handleGenerateEmail = (subject, body) => {
    setGeneratedEmail({ subject, body });
    setShowOutput(true);

    setTimeout(() => {
      document
        .getElementById("outputArea")
        ?.scrollIntoView({ behavior: "smooth" });
    }, 100);
  };

  const handleStartOver = () => {
    setCurrentView("initial");
    setShowOutput(false);
    setGeneratedEmail({ subject: "", body: "" });
    setStartFresh(false);
  };

  return (
    <div className="container">
      <header className="app-header">
        <h1>
          <a href="/" style={{ textDecoration: "none", color: "inherit" }}>
            <img src={logo} className="logo" alt="Paw Print Logo" />
            Paw Print Tools
          </a>
        </h1>
        <p className="app-subtitle">Tools for Woodside Paw Print staff</p>
      </header>

      {!showOutput && currentView === "initial" && (
        <InitialSelection onSelectForm={handleSelectForm} />
      )}

      {!showOutput && currentView === "interview" && (
        <InterviewForm
          onGenerateEmail={handleGenerateEmail}
          onStartOver={handleStartOver}
          startFresh={startFresh}
        />
      )}

      {!showOutput && currentView === "quote-check" && (
        <QuoteCheckForm
          onGenerateEmail={handleGenerateEmail}
          onStartOver={handleStartOver}
          startFresh={startFresh}
        />
      )}

      {currentView === "graphics-generator" && (
        <GraphicsGenerator onStartOver={handleStartOver} />
      )}

      {showOutput && (
        <OutputArea
          subject={generatedEmail.subject}
          body={generatedEmail.body}
          onStartOver={handleStartOver}
        />
      )}

      {!showOutput && currentView === "initial" && (
        <footer className="footer-text">
          This is an internal tool made for Woodside Paw Print staff.
        </footer>
      )}
    </div>
  );
}

export default App;
